"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormulaRange["default"];
  }
});
var _FormulaRange = _interopRequireDefault(require("./FormulaRange"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }